export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none">
    <path
      d="M2.40625 14.6016C2.5625 14.0547 2.875 13.5469 3.26562 13.1562L15.1406 1.28125C16.1172 0.304688 17.7188 0.304688 18.6953 1.28125L20.2188 2.80469C20.3359 2.92188 20.4531 3.07812 20.5312 3.19531C21.1953 4.17188 21.0781 5.5 20.2188 6.35938L8.34375 18.2344C8.30469 18.2734 8.22656 18.3125 8.1875 18.3906C7.79688 18.7031 7.36719 18.9375 6.89844 19.0938L2.17188 20.4609C1.85938 20.5781 1.50781 20.5 1.27344 20.2266C1 19.9922 0.921875 19.6406 1 19.3281L2.40625 14.6016ZM3.30469 18.1953L6.35156 17.2969C6.42969 17.2578 6.54688 17.2188 6.625 17.1797L5.21875 16.9062C4.90625 16.8281 4.63281 16.5938 4.59375 16.2812L4.32031 14.875C4.28125 14.9531 4.24219 15.0703 4.20312 15.1484L3.30469 18.1953ZM8.03125 15.8906L15.9609 7.96094L13.5 5.53906L5.60938 13.4688L6 15.4609L8.03125 15.8906Z"
      fill="#4B5851"
    />
  </svg>
);
